import { Anchor, Card, Icon, SearchSVG } from "@newsela/angelou";
import {
  actionNames,
  actionPrefixes,
  objectTypes,
  withTrackEvent,
  WithTrackEventProps,
} from "@newsela/snitch";

import DefaultNoImageIcon from "@/icons/NoImageSearchIcon";

import { ContentProps } from "@/components/ContentPromotions/types/ContentProps.interface";
import { cardCss, footerCss, iconCss, noImageCss } from "./TopicCard.style";

type CardWithAnchorPropsAndTrackEventProps =
  | React.ComponentProps<typeof Anchor>
  | React.ComponentProps<typeof Card>
  | WithTrackEventProps;

const CardWithTrackEvent = withTrackEvent(
  Card,
) as React.ForwardRefExoticComponent<CardWithAnchorPropsAndTrackEventProps>;

export const TopicCard = (content: ContentProps) => {
  const { href, image_url = null, title } = content || {};
  return (
    <CardWithTrackEvent
      actionName={actionNames.navigate}
      actionPrefix={actionPrefixes.initiate}
      dataProps={{ "data-qa-selector": "connections-card" }}
      href={href}
      objectType={objectTypes.user}
      __css={cardCss(image_url)}
    >
      {!image_url ? (
        <DefaultNoImageIcon
          // @ts-ignore dataProps and __cssFor
          dataProps={{
            "data-testid": "no-image-fallback-svg",
          }}
          __cssFor={{
            root: noImageCss,
          }}
        />
      ) : null}
      <div css={footerCss}>
        <Icon
          size={Icon.sizes.md}
          SvgComponent={SearchSVG}
          __cssFor={{
            root: iconCss,
          }}
        />
        {title}
      </div>
    </CardWithTrackEvent>
  );
};

export default TopicCard;
